import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { TripFlags } from '../models/interface/request.interface';
import { FeatureFlagService } from '../services/feature-flag.service';
@Injectable({
  providedIn: 'root'
})
export class FeatureFlagFacade {
  constructor(public flag: FeatureFlagService) {}
  featureFlags!: Observable<TripFlags>;

  getFlag = (): Observable<TripFlags> => {
    if (!this.featureFlags) {
      this.featureFlags = this.flag.getTripsFlag().pipe(shareReplay());
      return this.featureFlags;
    } else return this.featureFlags;
  };
}
